var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"inner"},[_c('p',{staticClass:"divider"}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('footer.riskWarn'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }